import {useState} from "react";
import {Modal} from "antd";
import FilterModal from "./FilterModal";

const FilterModalParent = ({visible, onCancel}) => {

    const [destroy, setDestroy] = useState(false)
    return (
        <Modal open={visible}
               width={500}
               onCancel={() => {
                   setDestroy(true)
                   onCancel()
               }}
               bodyStyle={{
                   minHeight: 100,
                   maxHeight: 600,
                   overflowY: "hidden",
               }}
               className="modalStyle modalStyleParent "
               footer={null}>
            <FilterModal onCancel={onCancel}
                         destroy={destroy}
                         onDestroy={(value) => setDestroy(value)}/>
        </Modal>
    )
}

export default FilterModalParent
